import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddHonors, Honors } from '../models/honors/honors';


@Injectable({
  providedIn: 'root'
})
export class HonorsService {

  constructor(
    private _http: HttpClient
  ) { }

    public getHonors(HonorsId?: number): Observable<Honors[]>{
        return this._http.get<Honors[]>(`${environment.api.url}/Honors?HonorsId=${HonorsId??''}`);
    }
  
    public deleteHonors(HonorsId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/Honors/${HonorsId}`);
    }
  
    public addHonors(model: AddHonors): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/Honors`, model);
    }
}
